import { useEffect, useRef } from 'react'

/**
 * Hook que cierra el menú cuando se hace click fuera del elemento referenciado.
 * @param {React.RefObject} ref - Ref del elemento dentro del cual el click se ignora.
 * @param {() => void} onClose - Callback a ejecutar cuando se detecta click fuera.
 */
export function useOutsideClick(ref, onClose) {
  const handlerRef = useRef(onClose)

  useEffect(() => {
    handlerRef.current = onClose
  }, [onClose])

  useEffect(() => {
    function handlePointerDown(/** @param {PointerEvent} event */ event) {
      const el = ref.current
      if (!el) return
      if (!el.contains(event.target)) {
        handlerRef.current()
      }
    }

    document.addEventListener('pointerdown', handlePointerDown)
    return () => document.removeEventListener('pointerdown', handlePointerDown)
  }, [ref])
}
